import { Bounce, toast } from "react-toastify";

export const successNotify = ({ text }) =>
  toast.success(text, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
    transition: Bounce,
    closeButton: false,
  });

export const errorNotify = ({ text }) =>
  toast.error(text, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
    transition: Bounce,
    closeButton: false,
  });
